// @view/panels/authentication/PasswordResetNotice.panel.tsx
import React from "react";
import EmptyView from "@view/EmptyView";
import type { VisibilityPhase } from "@ps-bridge/models/ui/visibilityPhase";
import PasswordResetNoticeView from "@view/authentication/PasswordResetNotice.view";

type PasswordResetNoticePanelProps = {
  phase: VisibilityPhase;
};

const PasswordResetNoticePanel: React.FC<PasswordResetNoticePanelProps> = ({ phase }) => {
  const phaseKeys = {
    hidden: "hidden",
    visible: "visible",
  } as const satisfies Record<VisibilityPhase, VisibilityPhase>;

  const render = {
    [phaseKeys.hidden]: <EmptyView />,
    [phaseKeys.visible]: <PasswordResetNoticeView />,
  } as const satisfies Record<VisibilityPhase, React.ReactElement>;

  return render[phase as keyof typeof render];
};

export default React.memo(PasswordResetNoticePanel, (prevProps, nextProps) => {
  return prevProps.phase === nextProps.phase;
});
